// Shared motion for sheets and pages. Entrances live in `styles/_overlay-motion.scss`; keep the curves in sync.

/** Long iOS-like ease-out. Sheets and pages enter, spring back and leave after a drag on it, so a release keeps its momentum. */
export const OVERLAY_EASE_OUT = 'cubic-bezier(0.32, 0.72, 0, 1)'

/** Ease-in-out for sheets and pages that leave from rest, such as after Close or Back. It starts gently. */
export const OVERLAY_EASE_IN_OUT = 'cubic-bezier(0.4, 0, 0.2, 1)'

/** Time for a released drag to spring back to rest, in milliseconds. */
export const OVERLAY_RETURN_DURATION = 250

/** Exit time in milliseconds for a surface that is nearly gone. */
export const OVERLAY_MIN_EXIT_DURATION = 200

/** Exit time in milliseconds for a fully extended page. */
export const OVERLAY_MAX_EXIT_DURATION = 450

/** Exit time in milliseconds for a fully extended sheet. A sheet travels about twice as far as a page. */
export const OVERLAY_SHEET_EXIT_DURATION = 550

/** Exit time in milliseconds for a page that leaves from rest, after Back. */
export const OVERLAY_PAGE_TAP_EXIT_DURATION = 360

/** Exit time in milliseconds for a sheet that leaves from rest, after Close or a backdrop tap. */
export const OVERLAY_SHEET_TAP_EXIT_DURATION = 450

/**
 * Times an exit by how much of the surface is still on screen.
 * @param {number} remaining Pixels the surface still has to travel.
 * @param {number} size Full travel of the surface in pixels. An unknown size counts as fully extended.
 * @param {number} [full=OVERLAY_MAX_EXIT_DURATION] Exit time when fully extended.
 * @returns {number} Exit duration in milliseconds.
 */
export function overlayExitDuration(remaining: number, size: number, full = OVERLAY_MAX_EXIT_DURATION): number {
  const extended = size > 0 ? Math.min(1, Math.max(0, remaining / size)) : 1

  return Math.round(OVERLAY_MIN_EXIT_DURATION + (full - OVERLAY_MIN_EXIT_DURATION) * extended)
}
